import React from 'react';

import { isStringEmpty } from 'utils/string';
import { NO_USERS_FOUND_TEXT, TYPE_USER_TEXT } from 'constants/appConstants';
import FormDropdown from 'components/common/inputWrapper/components/Select';

type DropdownOption = {
  value: string | number;
  label?: string;
};

type DebounceOptions = readonly [boolean, DropdownOption[], string, (code: string) => void];

interface Props {
  error?: React.ReactNode;
  value?: string | number | Array<string | number> | null;
  name?: string;
  label?: string;
  type?: string;
  handleChange: (e: { target: { name: string; value: string | number | Array<string | number> | null } }) => void;
  handleBlur?: (e: { target: { name?: string } }) => void;
  isDisabled?: boolean;
  classNamePrefix?: string;
  isMandatory?: boolean;
  debounceOptions: DebounceOptions;
  className?: string;
  iconComponent?: (option: Record<string, unknown>) => React.ReactNode;
  isClearable?: boolean;
  removeOptionsCallback?: (options: DropdownOption[]) => DropdownOption[];
  customSearchText?: string;
}

const DebounceFormDropdown: React.FC<Props> = (props) => {
  const {
    error,
    value,
    name,
    label,
    type,
    handleChange,
    handleBlur,
    isDisabled,
    classNamePrefix,
    isMandatory,
    debounceOptions,
    className,
    iconComponent,
    isClearable,
    removeOptionsCallback,
    customSearchText,
  } = props;

  const SEARCH_TEXT = customSearchText || `Search ${type || 'employee'}, hit enter to select`;

  const [isLoading, options, code, debounceFunction] = debounceOptions;

  const dropdownOptions = removeOptionsCallback ? removeOptionsCallback(options) : options;

  return (
    <FormDropdown
      isMandatory={isMandatory}
      name={name}
      onBlur={handleBlur}
      value={value}
      error={error}
      onChange={handleChange}
      options={dropdownOptions}
      label={label}
      placeholder={isLoading ? 'Loading' : SEARCH_TEXT}
      isLoading={isLoading}
      onInputChange={(code: string) => {
        if (!isStringEmpty(code)) {
          debounceFunction(code);
        }
      }}
      noOptionsMessage={() => (code.length ? NO_USERS_FOUND_TEXT : TYPE_USER_TEXT)}
      isDisabled={isDisabled}
      classNamePrefix={classNamePrefix}
      className={className}
      formatOptionLabel={iconComponent}
      isClearable={isClearable}
    />
  );
};

export default DebounceFormDropdown;
